import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { FormInputField } from '../../common/components/formFields';

const VehicleDescriptionForm = () => {
  const [ref, setRef] = useState(null);

  return (
    <>
      <Row>
        <Col md="12" className="vehicle-description__description-column">
          <FormInputField
            inputClassName="vehicle-description__textarea"
            label="Description"
            name="description"
            type="textarea"
            setRef={setRef}
          />
        </Col>
      </Row>
      <Row>
        <Col md="12" className="vehicle-description__description-column">
          <FormInputField
            label="Default description"
            inputClassName="vehicle-description__textarea"
            name="defaultDescription"
            type="textarea"
          />
        </Col>
      </Row>
    </>
  );
};

export default VehicleDescriptionForm;
